import merge from 'lodash/merge';

export const EVENT_PAGE = 0;
export const EVENT_IDENTIFY = 1;
export const EVENT_ACCOUNTCREATED = 2;
export const EVENT_DOWNLOADED = 3;
export const EVENT_SEARCHED = 4;
export const EVENT_CHECKOUTSTARTED = 5;
export const EVENT_ORDERCOMPLETED = 6;

export const EVENT_TRACK = 7;

export const EVENT_TRACKLINK = 8;
export const EVENT_TRACKFORM = 9;
export const EVENT_EXPERIMENTVIEWED = 10;
export const EVENT_PRODUCTLISTVIEWED = 11;
export const EVENT_SIGNEDIN = 12;
export const EVENT_INVITESENT = 13;
export const EVENT_PRODUCTSEARCHED = 14;
export const EVENT_SEMANTICCHECKOUTSTARTED = 15;
export const EVENT_SEMANTICORDERCOMPLETED = 16;
export const EVENT_PRODUCTADDEDTOWISHLIST = 17;
export const EVENT_SIGNEDUP = 18;
export const EVENT_ERROR = 19;
export const EVENT_CARTVIEWED = 20;
export const EVENT_PAYMENTINFOENTERED = 21;
export const EVENT_PRODUCTADDED = 22;
export const EVENT_PRODUCTREMOVED = 23;

export const pick = (o, props) =>
  Object.assign({}, ...props.map(prop => ({ [prop]: o[prop] })));

export const cloneDeep = x => merge({}, x);

export const compact = arr => arr.filter(x => x);

export const constant = x => () => x;

export const defaults = (...args) => Object.assign({}, ...args.reverse());

export const defaultsDeep = (target, ...def) =>
  merge(target, ...def.reverse(), cloneDeep(target));

export const isString = x =>
  typeof x === 'string' || (x != null && x.constructor === String);

export const pageDefaults = () => {
  const fullUrl = global.location.href;
  const idx = fullUrl.indexOf('#');
  const url = idx === -1 ? fullUrl : fullUrl.slice(0, idx);
  return {
    path: global.location.pathname,
    referrer: global.document.referrer,
    search: global.location.search,
    title: global.document.title,
    url
  };
};

export { merge };
